<ng-container
    *ngTemplateOutlet="shouldDisplayAttachmentFile ? attachmentTemplate : noAttachment">
</ng-container>

<ng-template #attachmentTemplate>

    <label>{{ attachment.LibellePJ }}</label>

    <div class="gup-C-flexGroup -row -justifyStart -alignCenter">

        <a class="gup-C-flexGroup__item"
           (click)="openAttachment()">
            <kal-icon>attach_file</kal-icon>
            {{ attachment.NomFichier }}
        </a>

        <span *ngIf="attachment.IsEnvoyee" class="gup-C-flexGroup__item  gup-U-color--500 small">
            Envoyée le : {{ attachment.DateEnvoi | date:'dd/MM/yyyy' }}
        </span>

    </div>

    <div class="gup-C-flexGroup__item gup-C-flexGroup -row -justifyStart -alignCenter">
        <app-simple-file-upload (fileReaded)="editAttachment($event)"
                                hideErrors
                                class="gup-C-flexGroup__item">

            <a class="gup-O-link -secondary small">
                <span>Modifier</span>
            </a>
        </app-simple-file-upload>

        <a class="gup-C-flexGroup__item  gup-O-link -secondary small"
           appConfirmTitle="Suppression de la pièce justificative"
           appConfirmBody="Souhaitez-vous supprimer cette pièce justificative ?"
           appConfirmSubmit="Supprimer"
           (appConfirm)="deleteAttachment()">
            Supprimer
        </a>
    </div>

    <kal-form-field class="pjReceived">

        <ng-template kalFormFieldLabel>
            <span>Pièce reçue</span>
            <span *ngIf="attachment.IsRecue">
                &nbsp;le {{ attachment.DateReception | date:'dd/MM/yyyy' }}
            </span>
        </ng-template>

        <kal-checkbox kalTheme="switch"
                      [value]="attachment.IsRecue"
                      (valueChanges)="toggleReceivedAttachment($event)">
        </kal-checkbox>

        <p class="small gup-U-color--400">
            Une fois la pièce justificative réceptionnée, le bénéficiaire ne pourra plus la modifier
            ou la supprimer depuis le site Internet.
        </p>

    </kal-form-field>

    <ng-container *ngTemplateOutlet="commentSectionTemplate; context:{displayCommentSection}"></ng-container>

</ng-template>

<ng-template #noAttachment let-attachment="attachment">

    <app-simple-file-upload (fileReaded)="addAttachment($event)">

        <a class="gup-C-moreInfos gup-O-link">
            <kal-icon>add</kal-icon>
            <span>Importer : {{voucherName}}</span>
        </a>
    </app-simple-file-upload>

    <div>
        <ng-container *ngTemplateOutlet="commentSectionTemplate; context:{displayCommentSection}"></ng-container>
    </div>

</ng-template>

<ng-template #commentSectionTemplate let-displayCommentSection="displayCommentSection">
    <ng-container *ngIf="hasVoucherComments(attachment) else addCommentTemplate">
        <kal-icon class="gup-U-color--400 gup-U-margin-right--mini" >chat_bubble_outline</kal-icon>

        <a class="gup-O-link -secondary"
           *ngIf="hasFilenameWithId || displayCommentSection"
           (click)="openVoucherCommentDialog(attachment)"
           kalTooltip>
            Modifier les commentaires
            <ng-template kalTooltipContent>
                <p [innerHtml]="attachmentComment | sanitize:'html'"></p>
            </ng-template>
        </a>
    </ng-container>

    <ng-template #addCommentTemplate>
        <a class="gup-O-link -secondary"
           *ngIf="hasFilenameWithId || displayCommentSection"
           (click)="openVoucherCommentDialog(attachment)">
            Ajouter des commentaires
        </a>
    </ng-template>
</ng-template>
